import React, { useContext } from "react";
import { useState, useEffect } from "react";
import Select from "react-select";
import { Table, Button, Form, Pagination } from "react-bootstrap";
import { Context } from "../../../../utils/context";
import { getData, getDownloadDataExcel, postData } from "../../../../utils/api";
import { Link } from "react-router-dom";
import {
  IDS,
  OrderStatusIds,
  ReturnStatusIds,
  RoleId,
  ServiceIds,
} from "../../../../utils/common";
import AssignOffCanvance from "../AssignDeliveryBoy";
import ProductModal from "../ProductModal";
import AssignReturnOffCanvance from "../AssignReturnDeliveryBoy";
import Pagination_Holder from "../../../common/Pagination_Holder/Pagination_Holder";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker from "react-datepicker";
import search1 from "../../../assets/icons/search.png";

import ExpiryDatePacking from "../ExpiryDatePacking";
import PackingTable from "../Packing/Packing";
import { ClipLoader } from "react-spinners";

function UnshippedTable({
  user,
  OrderByOptions,
  activeTab,
  resultsPerPageOptions,
  storeCategories,
  vendorServices,
  GetAllCounts,
}) {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
  } = useContext(Context);

  const [perPage, setperPage] = useState({
    value: 25,
    label: "Results per page: 25",
  });

  const [sortOrder, setSortOrder] = useState({
    value: "DESC",
    label: "Sort-by date (Descending)",
  });

  const [data, setData] = useState([]);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [searchOrderStatus, setSearchOrderSatatus] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [option, setOption] = useState();
  const [hideFilter, setHideFilter] = useState(false);
  const [storeCategory, setStoreCategory] = useState("");
  const [productCategory, setProductCategory] = useState("");
  // const [searchDate, setSearchDate] = useState("");
  // const [searchDateTo, setSearchDateTo] = useState("");
  const [searchCustomerContact, setSearchCustomerContact] = useState("");
  const [searchCustomer, setSearchCustomer] = useState("");
  const [searchDateTo, setSearchDateTo] = useState();
  const [searchDateFrom, setSearchDateFrom] = useState();

  const [searchStartTime, setSearchStartTime] = useState();
  const [searchEndTime, setSearchEndTime] = useState();

  const [searchInvoice, setSearchInvoice] = useState("");

  const [loader, setLoader] = useState("");

  const getDataAll = async () => {
    setLoader(true);
    const response = await getData(
      `/admin/orders/product-order?page=${onPageChange || 1}&per_page=${
        perPage?.value || 25
      }&term=${search}&searchOrderStatus=${
        OrderStatusIds.Preparing || ""
      }&storeCategory=${storeCategory}&invoice_no=${searchInvoice}&productCategory=${
        productCategory.value || ""
      }&sortOrder=${sortOrder?.value || "DESC"}&from=${
        searchDateFrom || ""
      }&to=${searchDateTo || ""}&start_time=${searchStartTime || ""}&end_time=${
        searchEndTime || ""
      }&name=${search || ""}&customer=${
        searchCustomer || ""
      }&customer_contact=${searchCustomerContact || ""}`,
    );
    await setData(response);
    setCurrentPage(response?.data?.current_page);
    // setperPage(response?.data?.per_page);
    settotalPages(response?.data?.total_pages);
    setSearch(response?.data?.search_name);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
    // await GetAllCounts();
    setLoader(false);
  };
  useEffect(() => {
    getDataAll();
  }, [reset, searchOrderStatus, onPageChange]);

  useEffect(() => {
    if (activeTab === "Unshipped") {
      getDataAll();
    }
  }, [activeTab]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  const [showAssign, setShowAssign] = useState({ show: 0, data: {} });

  const [showPaking, setShowPaking] = useState({ show: 0, data: {} });
  const [showReturnAssign, setShowReturnAssign] = useState({
    show: 0,
    data: {},
  });
  const [showDetails, setShowDetails] = useState({ show: 0, data: {} });

  const calculateTimeAgo = (date) => {
    const createdAt = new Date(date);
    const now = new Date();
    const diffInMilliseconds = now - createdAt;

    const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

    if (diffInDays >= 1) {
      return `${diffInDays} Day${diffInDays > 1 ? "s" : ""} Ago`;
    } else if (diffInHours >= 1) {
      return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} Ago`;
    } else {
      return `${diffInMinutes} Min Ago`;
    }
  };

  const formatTimeInIST = (date) => {
    const createdAt = new Date(date);
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    const istTime = createdAt.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      ...options,
    });
    // setFormattedTime(`${istTime} IST`);
    return istTime;
  };

  const ChangeOrderStatus = async (id, status_id) => {
    try {
      // Send the POST request to update the store's status
      await postData(`/admin/orders/product-order/update-status/${id}`, {
        order_status_id: status_id,
      });

      // Refresh the data after updating the store's status
      await getDataAll();
      GetAllCounts();
    } catch (error) {
      console.error("Error updating store status:", error);
    }
  };

  const downloadInvoice = async (invoiceUrl) => {
    try {
      const response = await fetch(invoiceUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = "invoice.pdf"; // Set your preferred filename
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const HandleDownload = async () => {
    if (data?.data?.data?.length <= 0) {
      alert("No record found");
    } else {
      try {
        await getDownloadDataExcel(
          `/admin/orders/download?page=${onPageChange || 1}&per_page=${
            perPage?.value || 25
          }&term=${search}&searchOrderStatus=${
            OrderStatusIds.Preparing || ""
          }&storeCategory=${storeCategory}&productCategory=${
            productCategory.value || ""
          }&sortOrder=${sortOrder?.value || "DESC"}&from=${
            searchDateFrom || ""
          }&to=${searchDateTo || ""}&start_time=${
            searchStartTime || ""
          }&end_time=${searchEndTime || ""}&name=${search || ""}&customer=${
            searchCustomer || ""
          }`,
          null,
          "Order List",
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  const [product, setProduct] = useState([]);

  const GetAllProduct = async () => {
    const response = await getData("/common/masters/product");
    if (response?.success) {
      setProduct(await Select2Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    GetAllProduct();
  }, []);

  return (
    <section className="pending-table_holder">
      <div className="quick-filters mt-3">
        <span className="quick-filters__label">
          <b>Quick Filters:</b>
        </span>
        <div className="quick-filters__tabs mt-3">
          <div className="row">
            <div className="col-md-3">
              <div className="num me-2">
                <label className="form-label">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="from"
                  value={searchDateFrom}
                  onKeyDown={(e) => e.preventDefault()}
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Check if year has 4 digits
                    if (year.length === 4 || value === "") {
                      setSearchDateFrom(value);
                      setonPageChange(1);
                    }
                  }}
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="num me-2">
                <label className="form-label">End Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="to"
                  value={searchDateTo}
                  onKeyDown={(e) => e.preventDefault()}
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Allow only if year is 4 digits or input is empty
                    if (year.length === 4 || value === "") {
                      setSearchDateTo(value);
                      setonPageChange(1);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row align-items-end mb-3">
        <div className="col-12 mb-2">
          <div className="row">
            <div className="col-lg-3 mb-2">
              <Form.Label>Select Product </Form.Label>
              <Select
                isSearchable
                options={product}
                value={productCategory}
                placeholder="Select Product"
                onChange={(e) => {
                  setProductCategory(e);
                }}
                classNamePrefix="searchProduct"
              />
            </div>
            <div className="col-lg-3 mb-2">
              <Form.Label>Customer Name</Form.Label>
              <Form.Control
                placeholder="Enter Customer Name"
                type="text"
                className="form-control"
                id=""
                value={searchCustomer}
                onChange={(e) => {
                  setSearchCustomer(e.target.value);
                }}
              />
            </div>

            <div className="col-lg-3 mb-2">
              <Form.Label>Customer Contact No</Form.Label>
              <Form.Control
                placeholder="Enter Customer Contact No"
                type="text"
                className="form-control"
                id=""
                value={searchCustomerContact}
                onChange={(e) => {
                  setSearchCustomerContact(e.target.value);
                }}
              />
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <Form.Label>Order Invoice No.</Form.Label>
              <Form.Control
                placeholder="Enter Invoice No"
                type="text"
                className="form-control"
                id=""
                value={searchInvoice}
                onChange={(e) => {
                  setSearchInvoice(e.target.value);
                }}
              />
            </div>
            <div className="col-xxl-1 col-xl-1  col-lg-1 col-md-1">
              <div className="Search me-2">
                <Form.Label>Search</Form.Label>
                <Button
                  type="button"
                  onClick={getDataAll}
                  className="btn btn-search"
                >
                  <img src={search1} className="search" alt="" />
                </Button>
              </div>
            </div>
            <div className="col-xxl-1 col-xl-1  col-lg-2 col-md-2">
              <div className="Search-1">
                <Form.Label>Reset</Form.Label>
                <button
                  type="button"
                  onClick={() => {
                    setSearchCustomerContact("");
                    setSearch("");
                    setSearchDateFrom("");
                    setSearchDateTo("");
                    setSearchEndTime("");
                    setSearchStartTime("");
                    setSearchCustomer("");
                    setProductCategory("");
                    setSearchInvoice("");
                    setReset(!reset);
                  }}
                  className="btn btn-reset"
                >
                  Reset
                </button>
              </div>
            </div>
            <div className=" col-xl-2 col-lg-4 col-md-6 col-12 mb-2">
              <Form.Label>Download Excel</Form.Label>
              <div>
                <button
                  className="btn btn-success "
                  type="button"
                  onClick={HandleDownload}
                >
                  Excel
                  <FontAwesomeIcon
                    icon="fa-solid fa-file-lines"
                    className="ms-2"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="filters-section">
        <div className="filters-section__label mb-3">
          <Button
            className="hide_btn"
            onClick={() => {
              setHideFilter(!hideFilter);
              setStoreCategory("");
              setSortOrder({
                value: "DESC",
                label: "Sort-by date (Descending)",
              });
              setperPage({ value: 25, label: "Results per page: 25" });
              setReset();
            }}
          >
            {" "}
            {!hideFilter ? "Hide Filter" : "Show Filter"}
          </Button>
          <h6>
            <span>{data?.data?.total} Orders</span>
          </h6>
        </div>
        {!hideFilter && (
          <div className="filters-section__controls">
            <div className="row">
              <div className="col-lg-3 mb-2">
                <Select
                  options={OrderByOptions}
                  // defaultValue={OrderByOptions[0]}
                  value={sortOrder}
                  onChange={(e) => setSortOrder(e)}
                  className="filters-section__dropdown"
                  classNamePrefix="react-select"
                  styles={customSelectStyles}
                />
              </div>
              <div className="col-lg-3 mb-2">
                <Select
                  options={resultsPerPageOptions}
                  // defaultValue={resultsPerPageOptions[0]}
                  value={perPage}
                  onChange={(e) => setperPage(e)}
                  className="filters-section__dropdown"
                  classNamePrefix="react-select"
                  styles={customSelectStyles}
                />
              </div>
              <div className="col-lg-3 mb-2">
                <Button
                  variant="outline-secondary"
                  className="filters-section__btn active me-1"
                  onClick={() => {
                    setonPageChange(1);
                    getDataAll();
                  }}
                >
                  Set Table Preferences
                </Button>

                <Button
                  variant="outline-secondary"
                  className="filters-section__btn"
                  onClick={() => {
                    setStoreCategory("");
                    setSortOrder({
                      value: "DESC",
                      label: "Sort-by date (Descending)",
                    });
                    setperPage({ value: 25, label: "Results per page: 25" });
                    setonPageChange(1);
                    setReset(!reset);
                  }}
                >
                  Refresh
                </Button>
              </div>

            </div>
          </div>
        )}
      </div> */}

      {/* Table Section */}
      {loader ? (
        <>
          <div className="text-center">
            <ClipLoader />
          </div>
        </>
      ) : (
        <div className="pending-table ">
          <Table striped bordered hover className="order-table" responsive>
            <thead>
              <tr>
                <th>Order Date</th>
                <th>Order details</th>
                <th>Products</th>
                <th>Total</th>
                <th>Delivery Details</th>
                <th>Order Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {data?.data?.data?.map((item, index) => (
                <tr key={index}>
                  <td className="order-date">
                    <div className="order-id">
                      {calculateTimeAgo(item?.createdAt)}
                    </div>
                    <div className="order-info">
                      <span>
                        {new Date(item?.createdAt).toISOString().split("T")[0]}
                      </span>
                    </div>
                    <div className="order-info">
                      <span>{formatTimeInIST(item?.createdAt)} IST</span>
                    </div>
                  </td>

                  {/* Owner Details */}
                  <td className="order-details">
                    <div className="order-id text-highlight">
                      {item?.invoice_no}
                    </div>
                    <div className="order-info">
                      <span>
                        <b>Buyer Name</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span className="text-highlight">{item?.User?.name}</span>
                    </div>
                    <div className="order-info">
                      <span className="order-info">
                        {item?.User?.contact_no}
                      </span>
                    </div>

                    <div className="order-info">
                      <span>{item?.Payment_Type?.name}</span>
                    </div>

                    {/* <div className="order-info">
                    <span>{item?.user?.type}</span>
                  </div> */}
                  </td>

                  <td className="order-details">
                    {/* {item?.Product_Order_Details?.map((product) => (
                      <>
                        <div className="text-highlight">
                          <span>
                            <b>Product Name</b>
                          </span>
                          :<span>{product?.Product?.name}</span>
                        </div>
                        <div className="order-info">
                          <span>
                            <b>Category Name</b>
                          </span>
                          :<span>{product?.Product?.p_category?.name} </span>
                        </div>
                      </>
                    ))} */}

                    {item?.Product_Order_Details?.map(
                      (product, productIndex) => (
                        <React.Fragment key={product.id}>
                          <div className="text-highlight">
                            <strong>Product {productIndex + 1}</strong>
                          </div>

                          <div className="text-highlight">
                            <span>
                              <b>Product Name</b>
                            </span>{" "}
                            :<span>{product?.Product?.name}</span>
                          </div>

                          <div className="order-info">
                            <span>
                              <b>Category Name</b>
                            </span>{" "}
                            :<span>{product?.Product?.p_category?.name}</span>
                          </div>

                          <hr />
                        </React.Fragment>
                      ),
                    )}
                    <div></div>
                    <div className=" mt-3">
                      <Button
                        className="action-btn active"
                        onClick={() =>
                          setShowDetails({
                            show: item?.id,
                            data: item?.Product_Order_Details,
                          })
                        }
                      >
                        View All Details
                      </Button>
                    </div>
                  </td>

                  <td className="order-details">
                    <div className="order-id">
                      <span>
                        <b>Total SubTotal</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_selling_price).toFixed(2)}/-
                      </span>
                    </div>
                    {/* <div className="order-id">
                    <span>Packing Charges</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.packing_charges} /-</span>
                  </div> */}
                    <div className="order-id">
                      <span>
                        <b>Delivery Charges</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.delivery_charges).toFixed(2)}/-
                      </span>
                    </div>
                    <div className="order-id">
                      <span>
                        <b>Offer Discount</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_offer_discount || 0).toFixed(2)} /-
                      </span>
                    </div>
                    <div className="order-id">
                      <span>
                        <b>Coupon Discount</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_coupon_discount).toFixed(2)}/-
                      </span>
                    </div>
                    {/* <div className="order-id">
                    <span>Refer Discount</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.refer_discount} /-</span>
                  </div> */}
                    <div className="order-id">
                      <span>
                        <b>Total Tax</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_tax).toFixed(2)}/-
                      </span>
                    </div>
                    <div className="order-id">
                      <span>
                        <b>Grand Total</b>
                      </span>
                    </div>
                    <div className="text-highlight">
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_amount).toFixed(2)}/-
                      </span>
                    </div>
                  </td>

                  <td>
                    <>
                      <div className="text-highlight">
                        <span>
                          {[
                            item?.User_Address?.first_name,
                            item?.User_Address?.last_name,
                          ]
                            .filter(Boolean)
                            .join(" ")}
                        </span>
                      </div>

                      <div className="order-info">
                        <span>
                          {[
                            item?.User_Address?.floor
                              ? `${item.User_Address.floor} floor`
                              : null,
                            item?.User_Address?.building,
                            item?.User_Address?.apartment,
                            item?.User_Address?.street,
                            item?.User_Address?.society,
                            item?.User_Address?.area,
                          ]
                            .filter(Boolean)
                            .join(", ")}
                        </span>
                      </div>

                      <div className="order-info">
                        <span>
                          {[
                            item?.User_Address?.Users_Address_Detail?.Country
                              ?.name,
                            item?.User_Address?.Users_Address_Detail?.State
                              ?.name,
                            item?.User_Address?.Users_Address_Detail?.City
                              ?.name,
                            item?.User_Address?.Users_Address_Detail?.Area
                              ?.name,
                            item?.User_Address?.Users_Address_Detail?.Pincode
                              ?.name,
                          ]
                            .filter(Boolean)
                            .join(", ")}
                        </span>
                      </div>

                      {item?.User_Address?.address_type && (
                        <div className="order-info">
                          <span>{item.User_Address.address_type}</span>
                        </div>
                      )}

                      {item?.User_Address?.contact_no && (
                        <div className="text-highlight">
                          <span>{item.User_Address.contact_no}</span>
                        </div>
                      )}

                      {item?.delivery_note && (
                        <div className="order-info">
                          <b>Delivery Note: {" "}</b>
                          <span>{item?.delivery_note}</span>
                        </div>
                      )}
                    </>
                  </td>
                  <td>{item.Order_status?.name}</td>
                  <td>
                    <div className="my-1">
                      <Button
                        className="action-btn active"
                        onClick={() =>
                          ChangeOrderStatus(
                            item?.id,
                            OrderStatusIds.OrderUnderQualityCheck,
                          )
                        }
                      >
                        {" "}
                        Send Order under Quality Check{" "}
                      </Button>
                    </div>
                    <div className="my-1">
                      <Button
                        className="action-btn"
                        onClick={() => downloadInvoice(IMG_URL + item?.invoice)}
                      >
                        Print Invoice
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          {data && data?.data?.data?.length > 0 ? (
            <Pagination_Holder
              onPageChange={currentPage}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
            />
          ) : (
            <p className="no-datashow">Sorry, No Data Found</p>
          )}
        </div>
      )}
      <AssignOffCanvance
        handleClose={() => {
          setShowAssign({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowAssign({ show: 0, data: {} })}
        show={showAssign?.show}
        data={showAssign?.data}
      />

      <AssignOffCanvance
        handleClose={() => {
          setShowAssign({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowAssign({ show: 0, data: {} })}
        show={showAssign?.show}
        data={showAssign?.data}
      />

      <ExpiryDatePacking
        handleClose={() => {
          setShowPaking({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowPaking({ show: 0, data: {} })}
        show={showPaking?.show}
        data={showPaking?.data}
      />

      <AssignReturnOffCanvance
        handleClose={() => {
          setShowReturnAssign({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowReturnAssign({ show: 0, data: {} })}
        show={showReturnAssign?.show}
        data={showReturnAssign?.data}
      />
      <ProductModal
        handleClose={() => {
          setShowDetails({ show: 0, data: {} });
        }}
        setShow={() => setShowDetails({ show: 0, data: {} })}
        show={showDetails?.show}
        data={showDetails?.data}
      />
    </section>
  );
}

export default UnshippedTable;
